// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3abc1a9e]:export{primaryColor:#00c2df;secondaryColor:#003c60;accentColor:#c41230}", ""]);
// Exports
module.exports = exports;
